import ReactDOM                   from 'react-dom';
import React                      from 'react' ;
import { Spin }                   from 'antd' ;
import { reaction }               from 'mobx' ;
import { Observer }               from 'mobx-react' ;

import { CTE }                    from './01_core' ;
import { MApp }                   from './09_model_app' ;
import { LoginScreen }            from './20_screen_login' ;
import { MainScreen }             from './30_screen_main' ;

import * as serviceWorker         from './serviceWorker';

// THIS IS TO IMPORT THE CSS STYLES
import './10_ui' ;


let is_pop_event = false ;

reaction( ( ) => MApp( ).url
        , (path) =>
        {
          if ( !is_pop_event )
               window.history.pushState( null, 'JMA', path ) ;

          is_pop_event = false ;
        } ) ;

window.onpopstate = function historyChange ( ev: any )
{
  if ( ev.type === "popstate" )
    {
       is_pop_event = true ;

       const app = MApp( ) ;
       
       app.open_page( app.page_from_url( window.location.pathname + window.location.hash ) ) ;
    }
}


const App: React.FC< { theme: string } > = ( props ) =>
<Observer render={ ( ) =>
{
  const page = MApp( ).cur_page.name
      , is_loading = page === CTE.SCREEN.LOADING ;

  return <div className={"flex-row flex-1 " + props.theme + (is_loading? ' flex-justify-center' : '')}>
    {  
        page === CTE.SCREEN.LOGIN? <LoginScreen /> 
      : is_loading               ? <Spin style={{justifySelf: 'center'}} size="large" />
      :                            <MainScreen />
    }
    </div> ;
}} /> ;



export function render_app ( theme:string )
{
  ReactDOM.render(<App theme={ theme } />, document.getElementById('root'));
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
